<template>
  <el-dialog
    :title="
      isEditDialog
        ? $t('dialog.titlePackageDetailEdit')
        : $t('dialog.titlePackageDetailAdd')
    "
    :visible="isShow"
    :close-on-click-modal="false"
    width="800px"
    @close="onClose"
  >
    <div class="das-form-container">
      <validation-observer ref="formValidator">
        <div class="das-form-group">
          <div class="das-form-group-title">
            {{ $t('views.configuration.generalInformation') }}
          </div>
          <div class="das-form-row">
            <div class="das-form-col flex col-6">
              <div class="das-form-input">
                <label class="label">
                  {{ $t('field.packageCode') }}
                </label>
                <div class="value-container">{{ packageInfo?.code }}</div>
              </div>
            </div>
            <div class="das-form-col flex col-6">
              <div class="das-form-input">
                <label class="label">
                  {{ $t('field.packageName') }}
                </label>
                <div class="value-container">{{ packageInfo?.name }}</div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col flex col-6">
              <div class="das-form-input">
                <label class="label">{{ $t('field.saleStartDate') }}</label>
                <div class="value-container">{{ packageInfo?.start_date }}</div>
              </div>
            </div>
            <div class="das-form-col flex col-6">
              <div class="das-form-input">
                <label class="label">{{ $t('field.saleEndDate') }}</label>
                <div class="value-container">{{ packageInfo?.end_date }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="das-form-group">
          <div class="das-form-group-title">
            {{ $t('views.configuration.detailInformationOfPackage') }}
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.effectiveDate') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.effectiveDate')"
                >
                  <SingleCalendar
                    v-model="formPackDetail.effective_date"
                    class="use-icon"
                    :date-data="formPackDetail.effective_date"
                    @input="onChangeEffectiveDate"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label required">
                  {{ $t('field.expiryDate') }}
                </div>
                <validation-provider
                  rules="required"
                  :name="$t('field.expiryDate')"
                >
                  <SingleCalendar
                    v-model="formPackDetail.expiration_date"
                    class="use-icon"
                    :date-data="formPackDetail.expiration_date"
                    @input="onChangeExpiredDate"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('field.unitPrice') }} ({{ packageInfo?.currency_code }})
                </div>
                <validation-provider
                  rules="number"
                  :name="$t('field.unitPrice')"
                >
                  <input
                    v-model="formPackDetail.unit_price"
                    v-numeric-only
                    type="number"
                    min="0"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div
                class="das-form-input"
                style="display: flex; flex-direction: column; height: 100%"
              >
                <div class="label">
                  {{ 'Phân loại' }}
                </div>
                <validation-provider
                  style="height: 100%; align-content: center"
                  rules="required"
                  :name="'TENL'"
                >
                  <div class="checkbox-wrap">
                    <input
                      id="NL"
                      v-model="formPackDetail.is_adult"
                      :value="true"
                      type="radio"
                      style="accent-color: #357456"
                    />
                    <!--   @change="changeAdultChild" -->
                    <label for="NL">{{ 'Người lớn' }}</label>
                  </div>
                  <div class="checkbox-wrap" style="padding-left: 10px">
                    <input
                      id="TE"
                      v-model="formPackDetail.is_adult"
                      :value="false"
                      type="radio"
                      style="accent-color: #357456"
                    />
                    <!--   @change="changeAdultChild" -->
                    <label for="TE">{{ 'Trẻ em' }}</label>
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col">
              <div class="checkbox-wrap">
                <input
                  id="all_week"
                  v-model="formPackDetail.is_all_week"
                  type="checkbox"
                  @change="onChangeAllWeekCheckbox"
                />
                <label for="all_week">{{ $t('field.allDaysInWeek') }}</label>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="flex" style="gap: 20px">
              <div class="das-form-col">
                <div class="checkbox-wrap">
                  <input
                    id="sunday"
                    v-model="formPackDetail.days_in_week"
                    value="8"
                    type="checkbox"
                  />
                  <label for="sunday">{{ $t('variables.sunday') }}</label>
                </div>
              </div>
              <div class="das-form-col">
                <div class="checkbox-wrap">
                  <input
                    id="monday"
                    v-model="formPackDetail.days_in_week"
                    value="2"
                    type="checkbox"
                  />
                  <label for="monday">{{ $t('variables.monday') }}</label>
                </div>
              </div>
              <div class="das-form-col">
                <div class="checkbox-wrap">
                  <input
                    id="tuesday"
                    v-model="formPackDetail.days_in_week"
                    value="3"
                    type="checkbox"
                  />
                  <label for="tuesday">{{ $t('variables.tuesday') }}</label>
                </div>
              </div>
              <div class="das-form-col">
                <div class="checkbox-wrap">
                  <input
                    id="wednesday"
                    v-model="formPackDetail.days_in_week"
                    value="4"
                    type="checkbox"
                  />
                  <label for="wednesday">{{ $t('variables.wednesday') }}</label>
                </div>
              </div>
              <div class="das-form-col">
                <div class="checkbox-wrap">
                  <input
                    id="thursday"
                    v-model="formPackDetail.days_in_week"
                    value="5"
                    type="checkbox"
                  />
                  <label for="thursday">{{ $t('variables.thursday') }}</label>
                </div>
              </div>
              <div class="das-form-col">
                <div class="checkbox-wrap">
                  <input
                    id="friday"
                    v-model="formPackDetail.days_in_week"
                    value="6"
                    type="checkbox"
                  />
                  <label for="friday">{{ $t('variables.friday') }}</label>
                </div>
              </div>
              <div class="das-form-col">
                <div class="checkbox-wrap">
                  <input
                    id="saturday"
                    v-model="formPackDetail.days_in_week"
                    value="7"
                    type="checkbox"
                  />
                  <label for="saturday">{{ $t('variables.saturday') }}</label>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="flex justify-between align-end">
                <div class="checkbox-wrap">
                  <validation-provider rules="" vid="enableLimitPeople">
                    <input
                      id="enableLimitPeople"
                      v-model="enableLimitPeople"
                      name="enableLimitPeople"
                      type="checkbox"
                    />
                    <label for="enableLimitPeople">
                      {{ this.$t('field.applicablePeopleAmount') }}
                    </label>
                  </validation-provider>
                </div>
                <div style="width: 150px">
                  <div class="das-form-input text-center">
                    <div class="label">{{ this.$t('variables.min') }}</div>
                    <validation-provider
                      v-numeric-only
                      :name="this.$t('field.minPeopleAmount')"
                    >
                      <input
                        v-model.number="formPackDetail.min_apply_people"
                        v-numeric-only
                        :disabled="!enableLimitPeople"
                        type="number"
                        min="0"
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input text-center" style="width: 150px">
                <div class="label">{{ this.$t('variables.max') }}</div>
                <validation-provider
                  rules="number"
                  :name="this.$t('field.maxPeopleAmount')"
                >
                  <input
                    v-model.number="formPackDetail.max_apply_people"
                    v-numeric-only
                    :disabled="!enableLimitPeople"
                    type="number"
                    min="0"
                  />
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-6">
              <div class="flex justify-between align-end">
                <div class="checkbox-wrap">
                  <input
                    id="limitNight"
                    v-model.number="enableLimitNight"
                    type="checkbox"
                  />
                  <label for="limitNight">
                    {{ this.$t('field.applicableNightAmount') }}
                  </label>
                </div>
                <div style="width: 150px">
                  <div class="das-form-input">
                    <validation-provider
                      rules="number"
                      :name="this.$t('field.minNightAmount')"
                    >
                      <input
                        v-model.number="formPackDetail.min_night"
                        v-numeric-only
                        :disabled="!enableLimitNight"
                        type="number"
                        min="0"
                      />
                    </validation-provider>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-col col-6">
              <div class="das-form-input" style="width: 150px">
                <validation-provider
                  rules="number"
                  :name="this.$t('field.maxNightAmount')"
                >
                  <input
                    v-model="formPackDetail.max_night"
                    v-numeric-only
                    :disabled="!enableLimitNight"
                    type="number"
                    min="0"
                  />
                </validation-provider>
              </div>
            </div>
          </div> -->
        </div>
      </validation-observer>
    </div>

    <span slot="footer" class="dialog-footer">
      <div class="button-containers">
        <button class="btn primary small outline" @click="onClose">
          {{ $t('button.cancel') }}
        </button>
        <button
          v-if="isEditDialog"
          class="btn primary small"
          @click="updatePackDetail"
        >
          {{ $t('button.update') }}
        </button>

        <button v-else class="btn primary small" @click="addPackDetail">
          {{ $t('button.create') }}
        </button>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import SingleCalendar from '@/components/ui/SingleCalendar.vue'

// eslint-disable-next-line no-unused-vars
import {
  // eslint-disable-next-line no-unused-vars
  getPackageDetailApi,
  // eslint-disable-next-line no-unused-vars
  addPackageDetailApi,
  // eslint-disable-next-line no-unused-vars
  updatePackageDetailApi
} from '@/api/Service_Policy/packageDetail'

export default {
  components: {
    SingleCalendar
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    isEditDialog: {
      type: Boolean,
      required: true
    },
    packageDetailId: Number,
    packageInfo: {
      type: Object
    }
  },
  data() {
    return {
      country: null,
      formPackDetail: {
        effective_date: null,
        expiration_date: null,
        unit_price: 0,
        applicable_day: null,
        max_apply_people: null,
        min_apply_people: null,
        max_night: null,
        min_night: null,
        package_id: null,
        days_in_week: [],
        is_all_week: false
      },
      enableLimitPeople: false,
      enableLimitNight: false
    }
  },
  watch: {
    'formPackDetail.days_in_week': {
      handler(val) {
        if (val?.length === 7) {
          this.formPackDetail.is_all_week = true
        } else {
          this.formPackDetail.is_all_week = false
        }
      }
    },
    isShow: {
      handler(val) {
        if (!val) {
          setTimeout(() => {
            this.resetPackDetailForm()
          }, 500)
        } else {
          this.attachData()
        }
      }
    }
  },
  methods: {
    // INPUTS
    checkStartEndDateValid() {
      if (
        this.formPackDetail?.effective_date &&
        this.formPackDetail?.expiration_date &&
        this.formPackDetail.effective_date > this.formPackDetail.expiration_date
      ) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.saleStartDateMustBeforeEnd')
        })
        this.formPackDetail.expiration_date = this.$moment(
          this.formPackDetail.effective_date
        )
          .add(1, 'd')
          .format('YYYY-MM-DD')
      }
    },
    onChangeEffectiveDate(date) {
      this.formPackDetail.effective_date = date
      this.checkStartEndDateValid()
    },

    onChangeExpiredDate(date) {
      this.formPackDetail.expiration_date = date
      this.checkStartEndDateValid()
    },

    onChangeAllWeekCheckbox(e) {
      this.formPackDetail.days_in_week = e.target.checked
        ? ['2', '3', '4', '5', '6', '7', '8']
        : []
    },

    // FORM
    getDefaultPackDetailForm() {
      return {
        effective_date: null,
        expiration_date: null,
        unit_price: 0,
        applicable_day: null,
        max_apply_people: null,
        min_apply_people: null,
        max_night: null,
        min_night: null,
        package_id: null,
        days_in_week: [],
        is_all_week: false,
        is_adult: true
      }
    },

    resetPackDetailForm() {
      this.formPackDetail = this.getDefaultPackDetailForm()
      this.enableLimitNight = false
      this.enableLimitPeople = false
    },

    getPackDetailFormPayload() {
      const payload = {
        id: this.formPackDetail?.id,
        effective_date: this.formPackDetail.effective_date,
        expiration_date: this.formPackDetail.expiration_date,
        unit_price: this.formPackDetail.unit_price,
        applicable_day: this.formPackDetail.days_in_week.toString(),
        max_apply_people: this.enableLimitPeople
          ? this.formPackDetail.max_apply_people
          : null,
        min_apply_people: this.enableLimitPeople
          ? this.formPackDetail.min_apply_people
          : null,
        max_night: this.enableLimitNight ? this.formPackDetail.max_night : null,
        min_night: this.enableLimitNight ? this.formPackDetail.min_night : null,
        package_id: this.packageInfo.id,
        is_adult: this.formPackDetail.is_adult
      }

      return payload
    },

    onClose() {
      this.$emit('close')
    },

    async addPackDetail() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      const payload = this.getPackDetailFormPayload()
      this.$emit('addPackageDetail', {
        payload
      })
    },

    async updatePackDetail() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }

      const payload = this.getPackDetailFormPayload()
      this.$emit('updatePackageDetail', {
        payload
      })
    },

    getPackageDetail() {
      getPackageDetailApi({ id: this.packageDetailId }).then(res => {
        const days_in_week = res.data.applicable_day
          ? res.data.applicable_day.split(',').map(item => Number(item))
          : []
        this.formPackDetail = {
          ...res.data,
          days_in_week: days_in_week,
          is_all_week: days_in_week.length === 7
        }
        this.enableLimitPeople =
          res.data.min_apply_people || res.data.max_apply_people
        this.enableLimitNight = res.data.min_night || res.data.max_night
      })
    },

    attachData() {
      if (!this.isEditDialog) {
        this.formPackDetail.effective_date = this.packageInfo?.start_date
        this.formPackDetail.expiration_date = this.packageInfo?.end_date
        this.formPackDetail.is_adult = true
      } else {
        this.getPackageDetail()
      }
    }

    // changeAdultChild(val) {
    //   console.log('hahaha', this.formPackDetail.is_adult, val)
    // }
  }
}
</script>

<style></style>
